import Header from './components/Header';
import Hero from './components/Hero';
import RankingSection from './components/RankingSection';
import ContactSection from './components/ContactSection';
import MediaSection from './components/MediaSection';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import AppSection from './components/AppSection';
import CarouselSection from './components/CarouselSection';
import TopicsSection from './components/TopicsSection';
import FaqSection from './components/FaqSection';
import UpdatesSection from './components/UpdatesSection';
import IndexSection from './components/IndexSection';
import AboutSection from './components/AboutSection';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <RankingSection />
        <ContactSection />
        <MediaSection />
        <CardsSection />
        <CommentsSection />
        <AppSection />
        <CarouselSection />
        <TopicsSection />
        <FaqSection />
        <UpdatesSection />
        <IndexSection />
        <AboutSection />
        <FeaturesSection />
      </main>
      <Footer />
    </div>
  );
}